export default __webpack_public_path__ + "static/media/Events_Calendar-512.bfc71dd3.png";